.kh{bottom:0.25rem;}